import { call, put } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import * as balancesActions from '../actions/balances';
import * as API from './api';

function* getBalances() {
  try {
    const balances = yield call(API.getBalances);
    yield put({
      type: balancesActions.GET_BALANCES_SUCCESS,
      payload: balances,
    });
  } catch (error) {
    error.name = 'Could not get Balances';
    yield put({ type: balancesActions.GET_BALANCES_ERROR, payload: error });
  }
}

function* addBalances({ payload }) {
  try {
    // create the tracking guids
    const requestId = uuidv4();

    yield call(API.addBalances, {
      ...payload,
      requestId,
    });

    yield put({
      type: balancesActions.ADD_BALANCES_SUCCESS,
    });
  } catch (error) {
    yield put({ type: balancesActions.ADD_BALANCES_ERROR, payload: error });
  }
}

const sagas = [
  [balancesActions.GET_BALANCES, getBalances],
  [balancesActions.ADD_BALANCES, addBalances],
];

export default sagas;
